import './App.css';
import SymptomChecker from './SymptomChecker';

function App() {
  return (
    <div className="App">
      <SymptomChecker />
    </div>
  );
}

export default App;
